// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.table-row-menu[data-v-b7dc4762] {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-pack: justify;\n        -ms-flex-pack: justify;\n            justify-content: space-between;\n}\n.edit-icon[data-v-b7dc4762], .trash-icon[data-v-b7dc4762] {\n    cursor: pointer;\n    color: #8C979A;\n}\n", ""]);
// Exports
module.exports = exports;
